import {_User as User} from "./_User"
import {_Dashboard as Dashboard} from "./_Dashboard";

export const ModuloCassaAPI = {
    Dashboard: Dashboard,
    User: User
};